import makeStyles from '@mui/styles/makeStyles'
import { appBarHeight } from '../app-toolbar/style'
import bgImage from './mindset-agent-preview.png'

export const useStyles = makeStyles(({ breakpoints, typography }) => ({
  root: {
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      height: `calc(100% - ${appBarHeight}px)`,
      top: appBarHeight,
      width: '100%',
      boxSizing: 'border-box',
      [breakpoints.up('sm')]: {
        width: 400
      },
      [breakpoints.up('md')]: {
        width: 550
      },
      [breakpoints.up('lg')]: {
        width: 700
      }
    }
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: '16px',
    paddingBottom: '32px'
  },
  agent: {
    flexGrow: 1,
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    overflow: 'hidden',
    boxSizing: 'border-box'
  },
  close: {
    zIndex: 3,
    position: 'absolute',
    top: '16px',
    right: '16px'
  },
  background: {
    position: 'relative',
    backgroundImage: `url(${bgImage})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    filter: 'blur(7px)',
    height: '100%',
    width: '100%'
  },
  ctaContainer: {
    position: 'absolute',
    zIndex: 2,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2rem',
    textAlign: 'center',
    height: '100%'
  },
  ctaContent: {
    backgroundColor: 'white',
    padding: '2rem',
    boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
    maxWidth: '400px',
    width: '100%'
  },
  message: {
    marginTop: '0.5rem',
    fontWeight: 500,
    ...typography.heading.h5
  },
  joinMessage: {
    marginTop: '1rem'
  },
  goToSignMessage: {
    marginTop: '0.5rem'
  }
}))
